const CHAVE = "suporte-guia";
const EVENTO = "suporte-guia";
const CONCLUIU = "suporte-guia-concluido";
// sessionStorage: o guia sobrevive à troca de tela, mas não a outra aba.
export const lerEstado = () => {
  try {
    return sessionStorage.getItem(CHAVE);
  } catch {
    return null;
  }
};
export function interpretar(bruto) {
  if (!bruto) return null;
  try {
    const e = JSON.parse(bruto);
    return Array.isArray(e?.guia?.passos) && Number.isInteger(e.passo) && e.passo >= 0 && e.passo < e.guia.passos.length
      ? e
      : null;
  } catch {
    return null;
  }
}
function gravar(e) {
  try {
    if (e) sessionStorage.setItem(CHAVE, JSON.stringify(e));
    else sessionStorage.removeItem(CHAVE);
  } catch {
    /* sem storage: o guia some */
  }
  window.dispatchEvent(new Event(EVENTO));
}
export const iniciarGuia = (guia) => gravar({ guia, passo: 0 });
export function irParaPasso(e, passo) {
  if (passo < e.guia.passos.length) return gravar({ ...e, passo: Math.max(0, passo) });
  gravar(null);
  // Concluir (não Esc/Sair) avisa o chat, que segue para "Resolvi seu problema?".
  window.dispatchEvent(new Event(CONCLUIU));
}
export const fecharGuia = () => gravar(null);
export function assinar(fn) {
  window.addEventListener(EVENTO, fn);
  window.addEventListener("storage", fn);
  return () => {
    window.removeEventListener(EVENTO, fn);
    window.removeEventListener("storage", fn);
  };
}
export function aoConcluirGuia(fn) {
  window.addEventListener(CONCLUIU, fn);
  return () => window.removeEventListener(CONCLUIU, fn);
}
/** Tem tamanho e está na largura da tela. Abaixo/acima da dobra vale: o guia rola até ele.
 *  Fora na horizontal não: é a gaveta fechada do celular. */
export function visivel(el) {
  const r = el.getBoundingClientRect();
  return r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth;
}
/**
 * Marca igual, ou rota com segmento variável: `menu:/negocios/[licenseId]/x` casa
 * `menu:/negocios/7f3a…/x` (e o contrário). `[qualquer]` vale um segmento inteiro.
 */
export function casaMarca(a, b) {
  if (a === b) return true;
  if (!a.startsWith("menu:/") || !b.startsWith("menu:/")) return false;
  const sa = a.split("/");
  const sb = b.split("/");
  const variavel = (s) => /^\[[^/]+\]$/.test(s);
  return sa.length === sb.length && sa.every((s, i) => s === sb[i] || variavel(s) || variavel(sb[i] ?? ""));
}
/** Elemento do passo; para item de menu escondido, o que abre o caminho até ele. */
export function acharAlvo(alvo, doc = document) {
  const marca = (v) =>
    [...doc.querySelectorAll("[data-guia]")].find(
      (el) => casaMarca(v, el.getAttribute("data-guia") ?? "") && visivel(el),
    );
  const el = marca(alvo);
  if (el) return { el };
  // Só o que mora no menu lateral pode estar escondido atrás de grupo ou da gaveta do celular.
  if (!alvo.startsWith("menu:/") && !alvo.startsWith("menu.")) return null;
  if (alvo.startsWith("menu:/")) {
    const href = alvo.slice("menu:".length);
    const grupo = [...doc.querySelectorAll("[data-guia-filhos]")].find(
      (g) =>
        (g.getAttribute("data-guia-filhos") ?? "").split(" ").some((f) => casaMarca(`menu:${f}`, `menu:${href}`)) &&
        visivel(g),
    );
    if (grupo) return { el: grupo, dica: "grupo" };
  }
  const gaveta = marca("menu:abrir");
  return gaveta ? { el: gaveta, dica: "gaveta" } : null;
}
const normal = (t) =>
  t
    .replace(/\s*\d+\s*$/, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
/** Passo sem marca: item de menu visível cujo nome aparece em negrito no texto (o badge numérico sai). */
export function alvoPeloTexto(texto, doc = document) {
  const nomes = [...texto.matchAll(/\*\*([^*]+)\*\*/g)].map((m) => normal(m[1] ?? ""));
  if (!nomes.length) return null;
  const el = [...doc.querySelectorAll('[data-guia^="menu:/"]')].find(
    (e) => visivel(e) && nomes.includes(normal(e.getAttribute("title") || e.textContent || "")),
  );
  return el ? { el } : null;
}
/** Balão ao lado do alvo, no primeiro lado com espaço (direita, esquerda, abaixo, acima), sempre dentro da tela. */
export function posicaoDoBalao(c, w, h, vw, vh, m = 12, gap = 18) {
  const limita = (v, max) => Math.min(Math.max(m, v), Math.max(m, max - m));
  const meioY = limita(c.top + c.height / 2 - h / 2, vh - h);
  const meioX = limita(c.left + c.width / 2 - w / 2, vw - w);
  if (c.left + c.width + gap + w <= vw - m) return { left: c.left + c.width + gap, top: meioY };
  if (c.left - gap - w >= m) return { left: c.left - gap - w, top: meioY };
  if (c.top + c.height + gap + h <= vh - m) return { left: meioX, top: c.top + c.height + gap };
  if (c.top - gap - h >= m) return { left: meioX, top: c.top - gap - h };
  return { left: meioX, top: limita(vh - h, vh - h) }; // tela pequena demais: rodapé
}
/** Clique que conclui o passo: dentro do alvo exato, exceto campos de digitar (esses avançam pelo botão). */
export function cliqueConclui(alvo, destino) {
  if (!alvo || alvo.dica || !(destino instanceof Node) || !alvo.el.contains(destino)) return false;
  const CAMPO =
    'input:not([type=checkbox]):not([type=radio]):not([type=file]), textarea, select, [contenteditable="true"]';
  return !(destino instanceof Element && destino.closest(CAMPO)) && !alvo.el.matches(CAMPO);
}
